export default "__VITE_ASSET__BkDdLm4v__"